import * as React from 'react';
import { useEffect, useState } from 'react';

import { SystemChangelogItem } from './types';
import { axios } from '../api';
import { ChangelogList } from '../component/ChangelogList';

export const PostCheckoutSurveyChangelog = () => {
  const [changelog, setChangelog] = useState<SystemChangelogItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [changelogError, setChangelogError] = useState('');

  const fetchChangelog = async () => {
    try {
      const response = await axios.get<SystemChangelogItem[]>(
        'system_changelog/post_checkout_survey_options'
      );
      setChangelog([...response.data].reverse());
    } catch {
      setChangelogError('Request failed, please try to refresh the page');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchChangelog();
  }, []);

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">How did you hear about Spot & Tango?</h1>
      <div className="border rounded-lg p-6">
        <h2 className="font-bold text-lg mb-4">Changelog</h2>
        <ChangelogList
          type="system"
          isLoading={isLoading}
          changelogError={changelogError}
          changelogItems={changelog}
        />
      </div>
    </div>
  );
};
